import { render, staticRenderFns } from "./businessDistrictEdit.vue?vue&type=template&id=783b8a89&"
import script from "./businessDistrictEdit.vue?vue&type=script&lang=js&"
export * from "./businessDistrictEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports